import Button from '@ahha/stableComponents/Button/Button'

import { useI18n } from '@ahha/i18n/i18n'

import { ConfirmExitWrapper } from '@/components/ConfirmExitDialog/styled'
import { ReactComponent as InfoIcon } from '@/assets/icons/common/info_icon.svg'

interface ConfirmExitDialogProps {
  waitingTasks: number
  runningTasks: number
  onCancel: () => void
  onExit: () => void
}

const ConfirmExitDialog = (props: ConfirmExitDialogProps) => {
  const { waitingTasks, runningTasks, onCancel, onExit } = props
  const { t } = useI18n()

  return (
    <ConfirmExitWrapper>
      <h5>{t('app_exit_dialog_title')}</h5>
      <p>{t('app_exit_dialog_desc1')}</p>
      <div className="confirm-exit__info">
        <span>{t('app_exit_dialog_info_running', { runningTasks })}</span>
        <span>{t('app_exit_dialog_info_waiting', { waitingTasks })}</span>
      </div>
      <p>{t('app_exit_dialog_desc2')}</p>
      <div className="confirm-exit__cta">
        <Button content={t('common_no')} size="sm" variant="transparent" onClick={onCancel} />
        <Button content={t('common_yes')} size="sm" onClick={onExit} />
      </div>
    </ConfirmExitWrapper>
  )
}

export default ConfirmExitDialog
